/* Core & libraries */
import React, {useEffect, useState} from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";
import { useNavigate } from "react-router";

/* Helpers, constants, custom methods, internal libraries */
import {useTeamService} from "../../../services/teamService";
import {useUserContext} from "../../../contexts/userContext";
import { TEAM_DETAILS_SETTINGS_ROUTE } from "../../../constants/routes";

/* Components */
import UCModal from "../../ucmodal";
import Content from "./content";
import { ReactComponent as CreateTeamSvg } from '../../../resources/images/people-dark-large.svg';

/* Styles */
import styles from "./styles";

const CreateTeamModal = ({showCreateTeamModal, setShowCreateTeamModal, getTeamsList}) => {
  const theme = useTheme();
  const classes = styles({ theme });
  const [teamNameError, setTeamNameError] = useState(false);
  const navigate = useNavigate();

  const { createTeam } = useTeamService({
    onError() {
      setTeamNameError(true)
    },
  });
  const userDetails = useUserContext();

  const companyEntityId = userDetails?.userInfo?.companyInfo?.companyEntityId

  useEffect(() => {
    if (!showCreateTeamModal) {
    }
  }, [showCreateTeamModal]);

  const handleCreateTeam = async (values, setPreviousTeam) => {
    //TODO: add validation
    const response = await createTeam(values)
    if (response) {
      setShowCreateTeamModal(false)
      // getTeamsList({ page: 1 });
      navigate('../' + TEAM_DETAILS_SETTINGS_ROUTE.replace(":teamId", response.group?.groupEntityId))
      setTeamNameError(false)
      setPreviousTeam("")
    } else {
      setTeamNameError(true)
      setPreviousTeam(values?.groupName)
    }    
  }
  return (
      <UCModal
        className={classes.createTeamModal}
        showModal={ showCreateTeamModal }
        setShowModal={ setShowCreateTeamModal }
        modalIcon={ <CreateTeamSvg /> }
        modalTitle={ <FormattedMessage id="createTeam.title"/> }
        modalDescription={ <FormattedMessage id="createTeam.description"/> }
        modalContent={ <Content setShowModal={setShowCreateTeamModal} handleCreateTeam={handleCreateTeam} companyEntityId={companyEntityId} teamNameError={teamNameError} setTeamNameError={setTeamNameError}/> }
        dataTestId="createTeamModal"
        onExited={() => {setTeamNameError(false)}}
      />
  )
}

export default CreateTeamModal;
